import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import thunk from 'redux-thunk';
import {productsReducer} from './reducers/products';
import {cartReducer} from './reducers/cart';
import {locationReducer} from './reducers/location';
import {braintreeReducer} from './reducers/braintree';
import {userReducer} from './reducers/user';
import {transactionsReducer} from './reducers/transactions';
import {orderFormReducer} from './reducers/orderForm';
import {couponReducer} from './reducers/coupon';
import {countriesReducer} from './reducers/countries';
import {corporateBundleReducer} from "./reducers/corporateBundle";
import {portalSettingsReducer} from "./reducers/portalSettings";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    combineReducers({
        productsReducer: productsReducer,
        cartReducer: cartReducer,
        locationReducer: locationReducer,
        braintreeReducer: braintreeReducer,
        userReducer: userReducer,
        transactionsReducer: transactionsReducer,
        orderFormReducer: orderFormReducer,
        couponReducer: couponReducer,
        countriesReducer: countriesReducer,
        corporateBundleReducer: corporateBundleReducer,
        portalSettingsReducer: portalSettingsReducer
    }),
    composeEnhancers(applyMiddleware(thunk))
);

export default store;